import gql from 'graphql-tag';
import { useQuery, ApolloError } from '@apollo/client';
import { isInactive } from 'domain/plans';

interface Props {
  planId?: number;
}
interface PlanInactiveData {
  planInactive: boolean;
  isMembershipPlan: boolean;
  displayName: string;
  reactivationEligibility: ReactivationEligibility;
}

interface Result {
  data?: PlanInactiveData;
  error?: ApolloError;
  loading: boolean;
  refetch: () => void;
  networkStatus: number;
}

export const usePlanInactive = ({ planId }: Props): Result => {
  const { data, loading, error, refetch, networkStatus } = useQuery<
    GetPlanInactiveQuery,
    GetPlanInactiveQueryVariables
  >(GET_PLAN_INACTIVE_QUERY, {
    skip: !planId,
    variables: { planId: planId || -1 },
  });

  let result;
  if (data) {
    result = {
      planInactive: isInactive(data.plan.status),
      isMembershipPlan: data.plan.isExclusiveMembershipPlan,
      reactivationEligibility: data.plan.reactivationEligibility,
      displayName: data.plan.displayName,
    };
  }

  return {
    data: result,
    error,
    loading,
    refetch,
    networkStatus,
  };
};

export const GET_PLAN_INACTIVE_QUERY = gql`
  query GetPlanInactive($planId: Int!) {
    plan(id: $planId) {
      id
      status
      displayName
      isExclusiveMembershipPlan
      reactivationEligibility {
        eligible
        reasons
      }
    }
  }
`;

export const getPlanInactiveMock = {
  plan: {
    id: 1,
    status: 'active',
    displayName: 'Home',
    isExclusiveMembershipPlan: false,
  },
};

export const usePlanInactiveMock = {
  data: { planInactive: false, isMembershipPlan: false, displayName: 'Home' },
  error: undefined,
  loading: false,
  refetch: () => null,
  networkStatus: 7,
};
